// eslint-disable-next-line import/no-extraneous-dependencies
import {lazy} from '@aboutyou/lazy-imports';

export const TrackCustomer = lazy(() =>
  import('./TrackCustomer.eager').then(mod => ({default: mod.TrackCustomer})),
);
